module.exports = __webpack_public_path__ + "assets/img/mecha-info-title-af0a3c45.png";